import {ActionTree} from "vuex";
import {ProcessImplementationState, ProcessImplementation} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<ProcessImplementationState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/process_implementations', {params: params})
        .then((response: AxiosResponse) => {
          const processImplementations: ProcessImplementation[] = response.data;
          commit('setProcessImplementations', processImplementations);
          return processImplementations;
        });
  },
  find({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].get(`/process_implementations/${id}`)
        .then((response: AxiosResponse) => {
          const processImplementation: ProcessImplementation = response.data;
          commit('setProcessImplementation', processImplementation);
          return processImplementation;
        });
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/process_implementations', params)
        .then((response: AxiosResponse) => {
          const processImplementation: ProcessImplementation = response.data;
          commit('addProcessImplementation', processImplementation);
          return processImplementation;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/process_implementations/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const processImplementation: ProcessImplementation = response.data;
          commit('updateProcessImplementation', processImplementation);
          return processImplementation;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/process_implementations/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteProcessImplementation', id);
        });
  }
}

export default actions;
